import type { AspectRatio, Media, MediaBlock } from '@/payload-types';

import { MediaDisplay } from '@/components/media-display';

export const MediaBlockComponent: React.FC<MediaBlock> = ({ ratio, media }) => {
  return <MediaDisplay className="mb-1" media={media as Media} ratio={ratio as AspectRatio} />;
};
